import { useEffect, useState } from "react";
import ManagedLaboratoryResponse from "../../../api/models/test-request/ManagedLaboratoryResponse";
import LaboratoriesApi from "../../../api/services/LaboratoriesApi";
import useEnv, { LogLevel } from "../../../hooks/env";

export default function useManagedLaboratories(
  tabEdited: boolean,
  setTabEdited: React.Dispatch<React.SetStateAction<boolean>>,
  activeTab: number,
) {
  const { api, log } = useEnv();
  const labsApi = new LaboratoriesApi(api);

  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [managedLaboratories, setManagedLaboratories] = useState<ManagedLaboratoryResponse[]>([]);

  const fetchManagedLaboratories = () => {
    labsApi
      .fetchManagedLaboratories()
      .then(({ data }) => setManagedLaboratories(data))
      .then(() => setLoading(false))
      .then(() => setTabEdited(false))
      .catch((e) => {
        log(LogLevel.ERROR, "Error getting user info", e);
        setError({ message: "Error getting user info", response: e });
      });
  };

  useEffect(() => {
    fetchManagedLaboratories();
  }, [tabEdited, activeTab]);

  return { error, loading, managedLaboratories };
}
